import React, { useEffect, useState } from "react";
import axios from "axios";
import { Eye, Info, Download, X } from "lucide-react";

export default function OrdersPage() {
  const [orders, setOrders] = useState(() => {
  const cached = localStorage.getItem("ordersCache");
  return cached ? JSON.parse(cached) : [];
});
  const [username, setUsername] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ service: "", info: "", note: "" });
  const [modalType, setModalType] = useState("info");
// 🔥 Fix Balance 0.00 issue — Sync username instantly
useEffect(() => {
  const syncUser = () => {
    const stored = JSON.parse(localStorage.getItem("user") || "{}");
    setUsername(stored.username || "");
  };

  syncUser(); // initial run

  window.addEventListener("userUpdated", syncUser);

  return () => window.removeEventListener("userUpdated", syncUser);
}, []);
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser?.username) {
      setUsername(storedUser.username);
      fetchOrders(storedUser.username);
    }
  }, []);

  const fetchOrders = async (username) => {
  try {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      `https://api.speedfollowinfo.com/api/orders/${username}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) {
      setOrders(res.data.orders);

      // 🔥 Save to cache
      localStorage.setItem(
        "ordersCache",
        JSON.stringify(res.data.orders)
      );
    }
  } catch (err) {
    console.error("❌ Fetch Orders Error:", err);
  }
};

  const getStatusStyle = (status) => {
    switch (status) {
      case "In Progress":
        return "bg-yellow-400 text-black font-semibold px-3 py-1 rounded-full text-xs";
      case "Complete":
        return "bg-green-500 text-black font-semibold px-3 py-1 rounded-full text-xs";
      case "Cancelled":
        return "bg-red-500 text-white font-semibold px-3 py-1 rounded-full text-xs";
      default:
        return "bg-gray-400 text-black font-semibold px-3 py-1 rounded-full text-xs";
    }
  };

  // 👁️ Modal: Show order info
  const handleViewInput = (service, info) => {
    setModalType("info");
    setModalData({ service, info });
    setShowModal(true);
  };

  // ℹ️ Modal: Show admin note
  const handleViewNote = (note) => {
    setModalType("note");
    setModalData({ note });
    setShowModal(true);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(modalData.info);
    alert("✅ Copied to clipboard!");
  };

  return (
    <div className="p-6 text-white min-h-screen">
      <h2 className="text-2xl font-bold mb-5 text-[#f2a900]">📦 My Orders</h2>

      {/* ✅ Universal Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50">
          <div className="bg-[#111827] p-6 rounded-2xl w-[90%] max-w-md text-white shadow-2xl relative">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-3 right-3 bg-red-500 hover:bg-red-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold"
            >
              <X size={18} />
            </button>

            <h2 className="text-xl font-bold text-[#7c3aed] mb-3 text-center">
              {modalType === "note" ? "Admin Note" : "Information"}
            </h2>

            {modalType === "note" ? (
              <div className="border border-gray-700 rounded-xl p-4 mb-4">
                <p className="text-gray-300 whitespace-pre-wrap">
                  {modalData.note || "No note available."}
                </p>
              </div>
            ) : (
              <div className="border border-gray-700 rounded-xl p-4 mb-4">
                <p className="text-gray-300 mb-2">
                  <strong>Service:</strong> {modalData.service || "N/A"}
                </p>
                <p className="text-gray-300">
                  <strong>Info:</strong> {modalData.info || "N/A"}
                </p>
              </div>
            )}

            {modalType === "info" && (
              <button
                onClick={handleCopy}
                className="w-full bg-[#7c3aed] hover:bg-[#6d28d9] py-2 rounded-lg font-semibold"
              >
                Copy
              </button>
            )}
          </div>
        </div>
      )}

      {/* ✅ Orders Table */}
      <div className="overflow-x-auto rounded-lg shadow-lg">
        <table className="w-full text-sm text-left border border-gray-700">
          <thead className="bg-[#111827] text-[#f2a900] uppercase">
            <tr>
              <th className="p-3">#Order</th>
              <th className="p-3">Cost (৳)</th>
              <th className="p-3">Status</th>
              <th className="p-3">Category</th>
              <th className="p-3">Created</th>
              <th className="p-3 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {orders.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center p-4 text-gray-400 italic">
                  No orders found
                </td>
              </tr>
            ) : (
              orders.map((order) => (
                <tr
                  key={order._id}
                  className="border-b border-gray-700 hover:bg-[#1f2937] transition"
                >
                  {/* ✅ Fix 1 — Proper order number */}
                  <td className="p-3 font-semibold text-[#f2a900]">
                    #{order.orderNumber || "—"}
                  </td>

                  <td className="p-3 text-[#00eaff] font-semibold">
                    ৳{order.price}
                  </td>

                  <td className="p-3">
                    <span className={getStatusStyle(order.status)}>
                      {order.status === "Cancelled" ? "Refunded" : order.status}
                    </span>
                  </td>

                  {/* ✅ Fix 2 — Correct category name */}
                  <td className="p-3 text-[#f2a900]">
                    {order.category || "No Category"}
                  </td>

                  {/* ✅ Fix 3 — Correct date source */}
<td className="p-3 text-gray-300">
  {order.createdAt
    ? new Date(order.createdAt).toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "—"}
</td>
                  {/* ✅ Action Buttons */}
                  <td className="p-3 flex justify-center items-center gap-3">
                    {/* 👁️ Always visible */}
                    <button
                      onClick={() => handleViewInput(order.service, order.info)}
                      className="bg-[#7c3aed] hover:brightness-125 p-2 rounded-lg transition flex items-center justify-center shadow-md hover:shadow-[#7c3aed]/50"
                      title="View Order Info"
                    >
                      <Eye size={20} color="white" />
                    </button>

                    {/* ℹ️ Admin Note */}
                    {order.adminNote && (
                      <button
                        onClick={() => handleViewNote(order.adminNote)}
                        className="bg-[#06b6d4] hover:brightness-125 p-2 rounded-lg transition flex items-center justify-center shadow-md hover:shadow-[#06b6d4]/50"
                        title="View Admin Note"
                      >
                        <Info size={20} color="white" />
                      </button>
                    )}

                    {/* ⬇️ Download File (Force Download) */}
{order.adminFile && (
  <a
    href={`https://api.speedfollowinfo.com/download${order.adminFile}`}
    className="bg-[#22c55e] hover:brightness-125 p-2 rounded-lg transition 
               flex items-center justify-center shadow-md 
               hover:shadow-[#22c55e]/50"
    title="Download File"
  >
    <Download size={20} color="white" />
  </a>
)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}